import { useMemo } from "react";
import { InputNumber } from "antd";

interface FrequencyInputNumberProps {
  con: Digital_Protocol_SoA_Table_Data.Condition;
  activityItem: Digital_Protocol_SoA_Table_Data.Entity;
  index: number;
  onBlur: any;
  isReadOnly?: boolean;
}

export function FrequencyInputNumber({
  con,
  activityItem,
  index,
  onBlur,
  isReadOnly,
}: FrequencyInputNumberProps) {
  const value = useMemo(
    () =>
      con.modality || con.modality_name ? con.modality_frequency ?? 1 : "",
    [con]
  );
  const disabled = useMemo(() => !con.modality && !con.modality_name, [con]);
  const error = useMemo(() => value && (value < 1 || value > 15), [value]);

  return (
    <InputNumber
      className={`td cell-input ${error ? "error" : ""}`}
      value={value}
      disabled={disabled}
      onBlur={(e) => onBlur(e, index, activityItem)}
      readOnly={isReadOnly}
    />
  );
}
